import { render, staticRenderFns } from "./EmailLogStatusBadge.vue?vue&type=template&id=2f151957&scoped=true&"
import script from "./EmailLogStatusBadge.vue?vue&type=script&lang=js&"
export * from "./EmailLogStatusBadge.vue?vue&type=script&lang=js&"
import style0 from "./EmailLogStatusBadge.vue?vue&type=style&index=0&id=2f151957&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f151957",
  null
  
)

export default component.exports